
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as jwt3dXZrQhqv_7MYxQYIQ8X8jf__45dDznbHRO5i09DpeFekMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue?macro=true";
import { default as riseidxHWA1DApn8xWYJ8AuPnC6I8GgyShf65Yk5kWkQ1lEosMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue?macro=true";
import { default as depositPRlCUzFWytq0FbHT_PGmDb4Ri_UQM_OE3BDthWyMjQ0Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue?macro=true";
import { default as deposit_45usejxgcI_45Z3fSRwQeORQeAZ8SdqZPr3Wdupf3ugzCsO9sMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue?macro=true";
import { default as _91accountId_93ipPb49GqgWKYC2_rkCDvaDbONtwVw10D90FWA5BTokEMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue?macro=true";
import { default as _91accountId_93WtPSZKrudyM1wuTOk3utt3qy960lt2yuoRn_45GpgfVMkMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue?macro=true";
import { default as fundCkILhuXgAhZZi7WDRbOWc4pED2DAzbVBtyln9FwuYOkMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue?macro=true";
import { default as indexqrKucsPpqOZVX5bQuE_KmmiNpx2GfzMZYyEiMzh_OoAMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue?macro=true";
import { default as riseidpsDwcXzo40NZkLLTMsyVYNkyBim1QXDFTRpeOkXVVnMMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue?macro=true";
import { default as accountbumy6mlSB2K8zhOp2FTfH3UWvj4PeIOuhb0grhgW9nIMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue?macro=true";
import { default as blocked3Mb9xaY92tSuQ7ZkzXV_45Qdlue62AmZJGeG5wMEViXg8Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue?macro=true";
import { default as referralPznQYXcnb8y1j5Uhjx9e_45qLeeRuSEiWY3rmdWXm2iZQMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue?macro=true";
import { default as securityqmeIpBi_IHZt1Ig1_4532MUivMOm9gxbBYuXoygH8MRcQMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue?macro=true";
import { default as sign_45outQUVHNq93izGY3j19YgDIikenu3qUog5ss0T8Y_45mDebUMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue?macro=true";
import { default as _91accountId_9392cF4xP8jdUU26Pd_2cjfJDkGtLNVkXI0bcrtb8Y_45RkMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue?macro=true";
import { default as _91accountId_9342MC47KYLVp91ZqJOZRASkz2i53U0yhRK62mM8lf7WkMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue?macro=true";
import { default as withdrawo_45QeIAhELIHEclxB_PmB_KkhXQsH_45MEGHbhD7pA0hqgMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue?macro=true";
import { default as dashboardPx_453CEoSF8_45d9t_GBxf7Syo3MPG1As2BdFQJiKe6PR0Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue?macro=true";
import { default as developertZr_45oRDkQHg1UN0GxTmamwoJgLabrCe6idmj1xQ_fI0Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue?macro=true";
import { default as loginMJyO_45zDKxSLHFXuPmFaBaQ1_451gqVi_45LmB6SvKxQezg8Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue?macro=true";
import { default as onboardingsOeSZyypCUPCb33Je6P1sk7lIq9ZpJhIG1sJLcjsuyoMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue?macro=true";
import { default as playgroundHBtlDie3tKVXFfHVBAhWqeKl9UCMYvmowMvkWV6eujgMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue?macro=true";
import { default as _2fa42jQTckDe4Unxw7id1WOsT8_45S3rIAQCm57Pz5tseQRoMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue?macro=true";
import { default as indexyQn0XSjRoGNG_n0UsJHnJpGvDMU_45IFQMBSoqMY_45G9uYMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue?macro=true";
import { default as code8W69UyY2I0C_45Esjb3jbMFnqcFW74B2ePGHIKKEIp_45BQMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue?macro=true";
import { default as code6vfm68TzIq2w5tTvjHVQ6gx3o4HUmYtIN_45GhqCrPRUQMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue?macro=true";
import { default as indexOX_45oaN7L6NVBDwN8LNCwVCtwnDN2RiZxJGzsmgzF8oUMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue?macro=true";
import { default as registerI6IXMGiQ6_45SV_DvCXSlWtBCb7iJQ3Dc6p8_oteZw4M8Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue?macro=true";
import { default as indexSqrJihU8Nx06GHjRdKkoFdY2hMG1AyxZT7b6lEIYoSgMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue?macro=true";
import { default as _91code_93hpsTE7h056SKuvZJBSW_45CKIYl6reNXgK8CFyuMNMYq8Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue?macro=true";
import { default as indexL_ssrtMFnxI4rWyYB2RBPv2u4A0jHgGRVuADEuo6Gm4Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue?macro=true";
import { default as sign_45document1XGEIbchUjKRXwFNvx_45agmgI2_45_45jA5QCDcWOAimKczEMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue?macro=true";
import { default as indexHSzBgbgM8jQjhEoZYYuhzO7aBu5FipdHxYt3Adi_45JJ0Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue?macro=true";
import { default as indexUFsSJ6foGcnTZgmk0A0GbPkPtNGb8crU36ZVVznXdgoMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue?macro=true";
import { default as importiuFiQFB4uBGmgnNMDUDZps8RLZj6TRBcwuuiTXjRBKUMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue?macro=true";
import { default as directxLFSTc1Uwl8cPIWMDs0Wp1NzG9EAVKhpBpj3Tto0ck0Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue?macro=true";
import { default as sumsubk2Bth7OMCGXlZ37sogzcyANzR4OTTDyxzAtpbRV5HScMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue?macro=true";
import { default as warmedHUSL6_wrg8IeQnZukTRSb6sM1glwwtyFMBPOQ40zo38Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue?macro=true";
import { default as batch_warmed_V4T69G_45RvB64tO2ovTKG_45I1bZkkImjcQODtZSHlWN0Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue?macro=true";
import { default as warmed_lightgj5pYfZgtZTFHCvTb7_JzNhBnt2kqtVye05msVFxb2YMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue?macro=true";
import { default as batch_warmed_lighte6_45nTjq1PO7zqxEkzPn566_45glHiqfql4iCJtM3aWeX0Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue?macro=true";
import { default as invitetPlBJ5niNlh8mJIbqrJIyZEI_A_45I3977QMmXVKtpjTAMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue?macro=true";
import { default as indexDqdI0K_45dX_IOOk4gIogGKZ_nffJQaaLpzisMfzdUPPYMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue?macro=true";
import { default as indexOGUsT7O7p3amXsD2FtbnnT6Ap_45MbMJvVE256iU6yqMIMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue?macro=true";
import { default as waitingJfjqg3HMI_456xz84Czj8oqahtPoV9iOayzO1mZ3ZOh8wMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue?macro=true";
import { default as businessRqC9Au66IdHVKZIPSFZRvuxSlVM0rZP5Z9UqFuYMmuMMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue?macro=true";
import { default as callbacklruma343IGEFNELTsfGq_45GfGtEfS0kjSnqPrekcDV7YMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue?macro=true";
import { default as _91id_93ZQYrXysxwWZnJokB3SjNqNOKwzUeDD_uu7oygyW1ge8Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue?macro=true";
import { default as indexwW2QtCg48cU7iPOhtVOp3d__45SItpp_ZDmRqzScg1Lg8Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue?macro=true";
import { default as _91uuid_93KvVBoeMSw60EvkPrvZZ0ClIYJ5Gw5JpavWvKKjYjTHwMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue?macro=true";
import { default as indexTLUUgiKGyieCDT8lXVYlN4QBKXEzBPw0usaH1kOpmN0Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue?macro=true";
import { default as indexKj3RWdabagGqWq6vSA_ChoSHhO1_456qDwYvLoTms3u6YMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue?macro=true";
import { default as index4naB3GdcpAHO0gYkaijBOXlQmx0bhG153__45FcxKvfdoMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue?macro=true";
import { default as optionsH_FZzVeWj7MmuRVYNAQ1bwdqmp6lVTP1sydZYuUaxOYMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue?macro=true";
import { default as riseid_45erc20_45withdrawhzKh6Tjg6ZEyJA3N6NQQwj_mQJX4cbQLBFEzDifhzPIMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue?macro=true";
import { default as _91token_93Nns5apSATZIZQQX2aT8P4OIL0q_45MgkkJDA2cm_45_Qii4Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue?macro=true";
import { default as index1ROpB85zp0XZ8N5o5J2jRczqHZk8SKCFjxG_1hMPQagMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue?macro=true";
import { default as indexDvDew6ut5budEtmUAny4VuAqV1wgwIrmrR_Mwmp2fdgMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue?macro=true";
import { default as indexzIt6Rz6kgso186v7rHdGXnfXuC4i1Zf5XdwJcOyR_45PMMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue?macro=true";
import { default as rampsaL61ya2hZXx4SnibXWgWcvNNIlF2mM_45WjoxU4Q3SMk0Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue?macro=true";
import { default as classificationRNjQgqx75vIx2QswEnfqRpnPiL8GPQMZB4SFGBB0epkMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue?macro=true";
import { default as _91id_93mfkeYuXSNKudvC2q2bpzK_XWA90TaJ7rMYlUxYXdT7UMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue?macro=true";
import { default as blockchain_45walletD8NzjKQ6JFcC_45mEdY_KG2CkyZdfuiwhGt7YdOgDMMRYMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue?macro=true";
import { default as dedicated_45addressTKs4KJbijMoHbU280671HwRLgAqQdesn705wjGO3DpcMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue?macro=true";
import { default as optionsYY_jjfMJL9tIPkAgWl_45MJUKzZ49dQ2igRKYbQyBuovEMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue?macro=true";
import { default as transaction_45history_45J_Rwglo6fbmSpyxNABBGmXt_45e_jCQq95JTFIqZDJ9QMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue?macro=true";
import { default as ushu9A6SnxSlp6nmwWi2WVyptTYf8dttUW5Kn5PI_sNjcMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue?macro=true";
import { default as eurvYKXxNPetB3_45ye4GRCtXhMZPyXwmurALW234c2dZtUEMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue?macro=true";
import { default as gbp9IHP0hVfOwfqpYNHlVLOl1GgSU_45Tvmus6epbApsSHbkMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue?macro=true";
import { default as ngnA0ZAgcJb76OnUM8QeBSbXC6U8HbM9gdKad2xm9qWl_sMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue?macro=true";
import { default as brlaCPRYfYvuWKmzqaqx0cpvQ2piZRIMb4UB6WFVIHLOZ6gMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue?macro=true";
import { default as forexmxfInyCULZ6UyGikyCAvZjtezxl6MpsIF_45l4j_d25AAMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue?macro=true";
import { default as krakenqrxHTXnvDV_5gI_oxdxN6QPAm5SMlOYduHhQ03E1GwsMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue?macro=true";
import { default as binance8y0SCRXahDzIp2scCB95cHzT_45BBbChc3mCMsownIubEMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue?macro=true";
import { default as coinbaseb1NGN1is_mkdJdPIsX2RinwcGwW2aurNPRvFzhZmKnQMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue?macro=true";
import { default as internationalnyWMemv9OOd8VSR_WleKfvcBvTS1fs4TasSR2FabMOUMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue?macro=true";
import { default as coinbase_walletiV1vmifzCdr9umX9QgAefGj2FzbaVjVond4xe5Wo9eEMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue?macro=true";
import { default as international_bankNI3LAxxq4q7mR_H3bqkZqWLu5DijMVTegkgePT88mR4Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue?macro=true";
import { default as indexv5mT6ksr_457kZTab7TAbaIdkfmCgHeDrZZB4ZddJdAOwMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue?macro=true";
import { default as _91network_93P_oynD33O1XlWnBy81uldiqWlCmbESVyhHtHFZL8h7YMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue?macro=true";
import { default as options_45UBzwpTJV5YiaZ3NeM0vA7mZ7qg0TonSuOWsem3Zre0Meta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue?macro=true";
import { default as coinbaseedqCm08x_45JlHvex6Tqo5XDAT284Q9KFCjzbxaf3BC_45wMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue?macro=true";
import { default as teamZKLPNnq6CFKRf7JsDNcpx30kswhKFY7ttrfu9NK4aywMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue?macro=true";
import { default as _91id_93f3yReknghXqnQhaZwVW4PaBSqa7zJMMr2ZIEpTUTHMYMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue?macro=true";
import { default as indexLjVBvHUtEr9bB5BNZ3k__45ZS0T_SKHAMJPGuQKrDzsKkMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue?macro=true";
import { default as verify_45walletrMsHvQCp898ZewHdh7gX69tlW4LoPWBBhF5SAFSslnkMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue?macro=true";
import { default as pay_schedule7yqT1Wd59SfegBwcQ5CR35K7WfuSg3uVVJhR38jH0aAMeta } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue?macro=true";
export default [
  {
    name: "jwt",
    path: "/jwt",
    meta: jwt3dXZrQhqv_7MYxQYIQ8X8jf__45dDznbHRO5i09DpeFekMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue")
  },
  {
    name: "fund",
    path: "/fund",
    meta: fundCkILhuXgAhZZi7WDRbOWc4pED2DAzbVBtyln9FwuYOkMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue"),
    children: [
  {
    name: "fund-riseid",
    path: "riseid",
    meta: riseidxHWA1DApn8xWYJ8AuPnC6I8GgyShf65Yk5kWkQ1lEosMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue")
  },
  {
    name: "fund-deposit",
    path: "deposit",
    meta: depositPRlCUzFWytq0FbHT_PGmDb4Ri_UQM_OE3BDthWyMjQ0Meta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue")
  },
  {
    name: "fund-deposit-us",
    path: "deposit-us",
    meta: deposit_45usejxgcI_45Z3fSRwQeORQeAZ8SdqZPr3Wdupf3ugzCsO9sMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue")
  },
  {
    name: "fund-external-account-accountId",
    path: "external-account/:accountId()",
    meta: _91accountId_93ipPb49GqgWKYC2_rkCDvaDbONtwVw10D90FWA5BTokEMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue")
  },
  {
    name: "fund-dedicated-address-accountId",
    path: "dedicated-address/:accountId()",
    meta: _91accountId_93WtPSZKrudyM1wuTOk3utt3qy960lt2yuoRn_45GpgfVMkMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: indexqrKucsPpqOZVX5bQuE_KmmiNpx2GfzMZYyEiMzh_OoAMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue")
  },
  {
    name: "riseid",
    path: "/riseid",
    meta: riseidpsDwcXzo40NZkLLTMsyVYNkyBim1QXDFTRpeOkXVVnMMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: accountbumy6mlSB2K8zhOp2FTfH3UWvj4PeIOuhb0grhgW9nIMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue")
  },
  {
    name: "blocked",
    path: "/blocked",
    meta: blocked3Mb9xaY92tSuQ7ZkzXV_45Qdlue62AmZJGeG5wMEViXg8Meta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue")
  },
  {
    name: "referral",
    path: "/referral",
    meta: referralPznQYXcnb8y1j5Uhjx9e_45qLeeRuSEiWY3rmdWXm2iZQMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue")
  },
  {
    name: "security",
    path: "/security",
    meta: securityqmeIpBi_IHZt1Ig1_4532MUivMOm9gxbBYuXoygH8MRcQMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue")
  },
  {
    name: "sign-out",
    path: "/sign-out",
    meta: sign_45outQUVHNq93izGY3j19YgDIikenu3qUog5ss0T8Y_45mDebUMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue")
  },
  {
    name: "withdraw",
    path: "/withdraw",
    meta: withdrawo_45QeIAhELIHEclxB_PmB_KkhXQsH_45MEGHbhD7pA0hqgMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue"),
    children: [
  {
    name: "withdraw-wire-accountId",
    path: "wire/:accountId()",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue")
  },
  {
    name: "withdraw-blockchain-accountId",
    path: "blockchain/:accountId()",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardPx_453CEoSF8_45d9t_GBxf7Syo3MPG1As2BdFQJiKe6PR0Meta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue")
  },
  {
    name: "developer",
    path: "/developer",
    meta: developertZr_45oRDkQHg1UN0GxTmamwoJgLabrCe6idmj1xQ_fI0Meta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingsOeSZyypCUPCb33Je6P1sk7lIq9ZpJhIG1sJLcjsuyoMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue")
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue")
  },
  {
    name: "sign-in-2fa",
    path: "/sign-in/2fa",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    meta: indexyQn0XSjRoGNG_n0UsJHnJpGvDMU_45IFQMBSoqMY_45G9uYMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue")
  },
  {
    name: "sign-in-code",
    path: "/sign-in/code",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue")
  },
  {
    name: "sign-up-code",
    path: "/sign-up/code",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue")
  },
  {
    name: "talent",
    path: "/talent",
    meta: indexOX_45oaN7L6NVBDwN8LNCwVCtwnDN2RiZxJGzsmgzF8oUMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue")
  },
  {
    name: "clients",
    path: "/clients",
    meta: indexSqrJihU8Nx06GHjRdKkoFdY2hMG1AyxZT7b6lEIYoSgMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue")
  },
  {
    name: "invite-code",
    path: "/invite/:code()",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexL_ssrtMFnxI4rWyYB2RBPv2u4A0jHgGRVuADEuo6Gm4Meta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue")
  },
  {
    name: "sign-document",
    path: "/sign-document",
    meta: sign_45document1XGEIbchUjKRXwFNvx_45agmgI2_45_45jA5QCDcWOAimKczEMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexHSzBgbgM8jQjhEoZYYuhzO7aBu5FipdHxYt3Adi_45JJ0Meta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue")
  },
  {
    name: "talent-import",
    path: "/talent/import",
    meta: importiuFiQFB4uBGmgnNMDUDZps8RLZj6TRBcwuuiTXjRBKUMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue")
  },
  {
    name: "talent-invite",
    path: "/talent/invite",
    meta: invitetPlBJ5niNlh8mJIbqrJIyZEI_A_45I3977QMmXVKtpjTAMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue"),
    children: [
  {
    name: "talent-invite-direct",
    path: "direct",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue")
  },
  {
    name: "talent-invite-sumsub",
    path: "sumsub",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue")
  },
  {
    name: "talent-invite-warmed",
    path: "warmed",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue")
  },
  {
    name: "talent-invite-batch_warmed",
    path: "batch_warmed",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue")
  },
  {
    name: "talent-invite-warmed_light",
    path: "warmed_light",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue")
  },
  {
    name: "talent-invite-batch_warmed_light",
    path: "batch_warmed_light",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue")
  }
]
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: indexDqdI0K_45dX_IOOk4gIogGKZ_nffJQaaLpzisMfzdUPPYMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: indexOGUsT7O7p3amXsD2FtbnnT6Ap_45MbMJvVE256iU6yqMIMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue")
  },
  {
    name: "sign-up-waiting",
    path: "/sign-up/waiting",
    meta: waitingJfjqg3HMI_456xz84Czj8oqahtPoV9iOayzO1mZ3ZOh8wMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue")
  },
  {
    name: "profile-business",
    path: "/profile/business",
    meta: businessRqC9Au66IdHVKZIPSFZRvuxSlVM0rZP5Z9UqFuYMmuMMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue")
  },
  {
    name: "sign-in-callback",
    path: "/sign-in/callback",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue")
  },
  {
    name: "invoices-add-id",
    path: "/invoices/add/:id()",
    meta: _91id_93ZQYrXysxwWZnJokB3SjNqNOKwzUeDD_uu7oygyW1ge8Meta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue")
  },
  {
    name: "talent-id",
    path: "/talent/:id()",
    meta: indexwW2QtCg48cU7iPOhtVOp3d__45SItpp_ZDmRqzScg1Lg8Meta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue")
  },
  {
    name: "auth-invite-uuid",
    path: "/auth/invite/:uuid()",
    meta: _91uuid_93KvVBoeMSw60EvkPrvZZ0ClIYJ5Gw5JpavWvKKjYjTHwMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue")
  },
  {
    name: "clients-id",
    path: "/clients/:id()",
    meta: indexTLUUgiKGyieCDT8lXVYlN4QBKXEzBPw0usaH1kOpmN0Meta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue")
  },
  {
    name: "invoices-add",
    path: "/invoices/add",
    meta: indexKj3RWdabagGqWq6vSA_ChoSHhO1_456qDwYvLoTms3u6YMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    meta: index4naB3GdcpAHO0gYkaijBOXlQmx0bhG153__45FcxKvfdoMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue")
  },
  {
    name: "subscription-options",
    path: "/subscription/options",
    meta: optionsH_FZzVeWj7MmuRVYNAQ1bwdqmp6lVTP1sydZYuUaxOYMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue")
  },
  {
    name: "riseid-erc20-withdraw",
    path: "/riseid-erc20-withdraw",
    meta: riseid_45erc20_45withdrawhzKh6Tjg6ZEyJA3N6NQQwj_mQJX4cbQLBFEzDifhzPIMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue")
  },
  {
    name: "auth-invite-b2b-token",
    path: "/auth/invite/b2b/:token()",
    meta: _91token_93Nns5apSATZIZQQX2aT8P4OIL0q_45MgkkJDA2cm_45_Qii4Meta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue")
  },
  {
    name: "management-company",
    path: "/management/company",
    meta: index1ROpB85zp0XZ8N5o5J2jRczqHZk8SKCFjxG_1hMPQagMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue")
  },
  {
    name: "accounts-add-funding",
    path: "/accounts/add-funding",
    meta: indexDvDew6ut5budEtmUAny4VuAqV1wgwIrmrR_Mwmp2fdgMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue")
  },
  {
    name: "accounts-add-withdraw",
    path: "/accounts/add-withdraw",
    meta: indexzIt6Rz6kgso186v7rHdGXnfXuC4i1Zf5XdwJcOyR_45PMMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue")
  },
  {
    name: "accounts-add-withdraw-ramps",
    path: "/accounts/add-withdraw/ramps",
    meta: rampsaL61ya2hZXx4SnibXWgWcvNNIlF2mM_45WjoxU4Q3SMk0Meta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue")
  },
  {
    name: "clients-id-classification",
    path: "/clients/:id()/classification",
    meta: classificationRNjQgqx75vIx2QswEnfqRpnPiL8GPQMZB4SFGBB0epkMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue")
  },
  {
    name: "payments-receipts-fund-id",
    path: "/payments/receipts/fund/:id()",
    meta: _91id_93mfkeYuXSNKudvC2q2bpzK_XWA90TaJ7rMYlUxYXdT7UMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue")
  },
  {
    name: "accounts-add-funding-options",
    path: "/accounts/add-funding/options",
    meta: optionsYY_jjfMJL9tIPkAgWl_45MJUKzZ49dQ2igRKYbQyBuovEMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue"),
    children: [
  {
    name: "accounts-add-funding-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue")
  },
  {
    name: "accounts-add-funding-options-dedicated-address",
    path: "dedicated-address",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue")
  }
]
  },
  {
    name: "payments-transaction-history",
    path: "/payments/transaction-history",
    meta: transaction_45history_45J_Rwglo6fbmSpyxNABBGmXt_45e_jCQq95JTFIqZDJ9QMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue")
  },
  {
    name: "accounts-add-withdraw-options",
    path: "/accounts/add-withdraw/options",
    meta: options_45UBzwpTJV5YiaZ3NeM0vA7mZ7qg0TonSuOWsem3Zre0Meta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue"),
    children: [
  {
    name: "accounts-add-withdraw-options-us",
    path: "us",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue")
  },
  {
    name: "accounts-add-withdraw-options-eur",
    path: "eur",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue")
  },
  {
    name: "accounts-add-withdraw-options-gbp",
    path: "gbp",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue")
  },
  {
    name: "accounts-add-withdraw-options-ngn",
    path: "ngn",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue")
  },
  {
    name: "accounts-add-withdraw-options-brla",
    path: "brla",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue")
  },
  {
    name: "accounts-add-withdraw-options-forex",
    path: "forex",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue")
  },
  {
    name: "accounts-add-withdraw-options-kraken",
    path: "kraken",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue")
  },
  {
    name: "accounts-add-withdraw-options-binance",
    path: "binance",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase",
    path: "coinbase",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue")
  },
  {
    name: "accounts-add-withdraw-options-international",
    path: "international",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase_wallet",
    path: "coinbase_wallet",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue")
  },
  {
    name: "accounts-add-withdraw-options-international_bank",
    path: "international_bank",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet-network",
    path: "blockchain-wallet/:network()",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue")
  }
]
  },
  {
    name: "accounts-add-callback-coinbase",
    path: "/accounts/add/callback/coinbase",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue")
  },
  {
    name: "management-company-create-team",
    path: "/management/company/create/team",
    meta: teamZKLPNnq6CFKRf7JsDNcpx30kswhKFY7ttrfu9NK4aywMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue")
  },
  {
    name: "payments-receipts-payment-id",
    path: "/payments/receipts/payment/:id()",
    meta: _91id_93f3yReknghXqnQhaZwVW4PaBSqa7zJMMr2ZIEpTUTHMYMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue")
  },
  {
    name: "management-company-create",
    path: "/management/company/create",
    meta: indexLjVBvHUtEr9bB5BNZ3k__45ZS0T_SKHAMJPGuQKrDzsKkMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue")
  },
  {
    name: "accounts-add-callback-verify-wallet",
    path: "/accounts/add/callback/verify-wallet",
    meta: verify_45walletrMsHvQCp898ZewHdh7gX69tlW4LoPWBBhF5SAFSslnkMeta || {},
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue")
  },
  {
    name: "documents-payschedule-pay_schedule",
    path: "/documents/:payschedule()/pay_schedule",
    component: () => import("/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue")
  }
]